import { useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

import type { Response, MutationVars } from './mutation'
import patchFlagFeedback from './mutation'

export const usePatchFlagFeedbackMutation: WrappedMutation<Response, MutationVars> = () =>
  useMutation<Response, MutationVars>(patchFlagFeedback, {
    client: agentClient,
    fetchPolicy: 'network-only',
  })
